// @flow
import * as React from 'react';
import { MainMenu } from './main-menu';
import { Outlet } from 'react-router-dom';
import { Stack } from '@mui/material';
import { UrgentNotifications } from './urgent-notifications/urgent-notifications';
import { useReactiveVar } from '@apollo/client';
import { menuCollapsed } from './menu-toggle-button';

export const MainLayout = () => {
  const collapsed = useReactiveVar(menuCollapsed);

  return <Stack direction={'row'} alignItems={'stretch'} height={'100vh'}>
    <MainMenu />
    <Stack flex={1} maxWidth={`calc(100% - ${collapsed ? 50 : 250}px)`}
           sx={{transition: 'all .5s ease-in-out'}}
           maxHeight={'100vh'} ml={`${collapsed ? 50 : 250}px`}>
      <UrgentNotifications />
      <Outlet />
    </Stack>
  </Stack>
};
